/* eslint-disable */
// /src/pages/NoticePage.jsx  (사용자용 공지 목록)
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { listNotices } from "../services/announcementsPublicService";
import { useAppConfig } from "../context/AppConfigContext";
import PageTopBar from "../components/PageTopBar";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #f7faff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Body = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: auto auto auto 1fr auto;
  row-gap: 14px;
  padding: 16px;
`;

const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 4px;
`;
const HeaderImg = styled.img`
  display: block;
  height: auto;
`;

/* 상단 안내 카드 */
const IntroCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
  padding: 18px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
`;
const IntroText = styled.div`
  h2 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 900;
    color: #0f172a;
  }
  p {
    margin: 0;
    color: #475569;
    line-height: 1.5;
    font-size: 14px;
    white-space: pre-line; /* 줄바꿈 그대로 표시 */
  }
`;
const Mascot = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #fff7ed;
  display: grid;
  place-items: center;
  font-size: 28px;
  box-shadow: inset 0 0 0 2px #ffe4c7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
    display: block;
  }
`;

const Section = styled.section`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
  padding: 12px;
`;
const SectionTitle = styled.h3`
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 900;
  color: #0f172a;
`;

const NoticeList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
`;
const NoticeItem = styled.li`
  background: #f1f5ff;
  border-radius: 12px;
  margin: 5px 0px;
  padding: 20px 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  transition: transform 0.06s ease, box-shadow 0.12s ease, background 0.12s ease;
  &:active {
    transform: translateY(1px);
  }
`;
const NoticeText = styled.div`
  display: grid;
  gap: 4px;
  .title {
    font-size: 15px;
    font-weight: 800;
    color: #0f172a;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    line-height: 1.2;
  }
  .meta {
    font-size: 12px;
    color: #64748b;
    display: flex;
    gap: 8px;
  }
`;
const DotNew = styled.i`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
`;
const CTA = styled.button`
  margin-top: 6px;
  height: 48px;
  width: 100%;
  border: 0;
  border-radius: 12px;
  background: ${(p) => p.$bg || "var(--color-brand,#D9A679)"};
  color: ${(p) => p.$color || "#ffffff"};
  font-weight: 900;
  font-size: 15px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  &:active {
    transform: translateY(1px);
  }
`;
const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

/* 섹션 제목 옆에 쓰는 작은 스피너 */
const InlineSpinner = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(148, 163, 184, 0.5);
  border-top-color: #4f46e5;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

function fmt(d) {
  try {
    return (d instanceof Date ? d : new Date(d)).toISOString().slice(0, 10);
  } catch {
    return "-";
  }
}
function isNew(d) {
  try {
    const dd = (d instanceof Date ? d : new Date(d)).getTime();
    return Date.now() - dd < 1000 * 60 * 60 * 24 * 7; // 7일 이내
  } catch {
    return false;
  }
}

export default function NoticePage() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(true); // 스피너 최소 노출용

  // ✅ 기본 5개만 노출, "공지 더 보기" 클릭 시 5개씩 증가
  const [visibleCount, setVisibleCount] = useState(5);

  const { config, loading: configLoading } = useAppConfig();
  const detail = config.detailScreens || {};
  const noticeCfg = detail.noticeCenter || {};

  const headerImg = noticeCfg.headerImg || "";
  const sectionTitleText = noticeCfg.sectionTitle || "최근 공지";
  const seeMoreLabel = noticeCfg.seeMoreLabel || "공지 더 보기";
  const seeMoreBgColor = noticeCfg.seeMoreBgColor || "#788fd3";
  const seeMoreTextColor = noticeCfg.seeMoreTextColor || "#ffffff";

  // 상단 안내 카드: 관리자 설정값
  const cardTitle =
    noticeCfg.cardTitle || "서비스 업데이트와 주요 소식";
  const cardDescription =
    noticeCfg.cardDescription ||
    "중요한 변경사항, 점검 안내, 신규 기능 출시 소식을\n가장 먼저 알려드립니다.";
  const channelIconImg = noticeCfg.channelIconImg || "";

  const openDetail = (id) => nav(`/notice/${id}`);

  useEffect(() => {
    let alive = true;

    (async () => {
      const start = Date.now();
      try {
        setLoading(true);
        setShowSpinner(true);

        const list = await listNotices({ limit: 100 });
        if (!alive) return;
        setItems(list);
      } finally {
        if (!alive) return;

        setLoading(false);

        const elapsed = Date.now() - start;
        const remain = Math.max(0, 2000 - elapsed); // 최소 2초

        if (remain === 0) {
          setShowSpinner(false);
        } else {
          setTimeout(() => {
            if (alive) setShowSpinner(false);
          }, remain);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  // 공지 목록이 바뀔 때마다 기본 5개부터 다시 시작
  useEffect(() => {
    setVisibleCount(5);
  }, [items.length]);

  const has = items.length > 0;
  const displayLoading = loading || showSpinner; // ✅ 둘 중 하나라도 true면 "로딩상태"

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < items.length;

  const handleLoadMore = () => {
    if (!hasMore) return;
    setVisibleCount((prev) => Math.min(prev + 5, items.length));
  };

  return (
    <Wrap>
      <Sheet>
        <PageTopBar />

        <Body>
          {/* 공지센터 헤더 이미지 (원본 사이즈) */}
          {!configLoading && headerImg && (
            <HeaderSection>
              <HeaderImg src={headerImg} alt="공지센터 헤더" />
            </HeaderSection>
          )}

          {/* 상단 안내 카드 - 동적 텍스트 + 아이콘 */}
          <IntroCard>
            <IntroText>
              <h2>{cardTitle}</h2>
              <p>{cardDescription}</p>
            </IntroText>
            <Mascot>
              {channelIconImg ? (
                <img src={channelIconImg} alt="공지 카드 아이콘" />
              ) : (
                "🧸"
              )}
            </Mascot>
          </IntroCard>

          <Section>
            {/* 제목 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <SectionTitle style={{ marginBottom: 0 }}>
                {sectionTitleText}
              </SectionTitle>
            </div>

            {/* 리스트 영역: 스피너 + 리스트/빈 상태 */}
            <div style={{ minHeight: 140 }}>
              {displayLoading && (
                <div
                  style={{
                    padding: 16,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginTop: 50,
                  }}
                >
                  <InlineSpinner />
                </div>
              )}

              {!displayLoading && !has && (
                <div style={{ padding: 12, color: "#64748b" }}>
                  등록된 공지가 없습니다.
                </div>
              )}

              {!displayLoading && has && (
                <NoticeList>
                  {visibleItems.map((n) => (
                    <NoticeItem key={n.id} onClick={() => openDetail(n.id)}>
                      <NoticeText>
                        <div className="title">
                          {n.title}
                          {isNew(n.publishedAt) && <DotNew />}
                        </div>
                        <div className="meta">
                          <span>{fmt(n.publishedAt)}</span>
                        </div>
                      </NoticeText>
                      <div>›</div>
                    </NoticeItem>
                  ))}
                </NoticeList>
              )}
            </div>

            {/* 공지 더 보기: 남은 공지가 있을 때만 노출 */}
            {!displayLoading && has && hasMore && (
              <CTA
                onClick={handleLoadMore}
                $bg={seeMoreBgColor}
                $color={seeMoreTextColor}
              >
                {seeMoreLabel}
              </CTA>
            )}
          </Section>

          <BottomPad />
        </Body>
      </Sheet>
    </Wrap>
  );
}
